import { z } from 'zod'

// Persisted-and-reread across reloads, so it fails closed rather than trusting the shape.
export const chunkRecoveryLatchSchema = z.object({ count: z.number(), firstAt: z.number() })
